module.exports = __webpack_public_path__ + "static/img/value3.ac07aac.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/value3.png
// module id = FTXz
// module chunks = 1